import { Injectable, EventEmitter } from '@angular/core';

 
@Injectable()
export class SpinnerService {
    
    public spinnerChanged$: EventEmitter<boolean>;
    private displaySpinner: boolean;
    private message: string;

    constructor() {
      this.spinnerChanged$ = new EventEmitter();
      this.displaySpinner = false;
      this.message = "";
    }
 
    start(message: string): void {
        this.message = message;
        this.toggleSpinner(true);
    }

    stop(): void {
        this.toggleSpinner(false);
    }

    getMessage(): string {
        return this.message;
    }

    isVisible() : boolean {
        return this.displaySpinner;
    }

    private toggleSpinner(display: boolean): void {
      this.displaySpinner = display;
      this.spinnerChanged$.emit(this.displaySpinner);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.service.ts